"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeQualityAutoTestStep = void 0;
const purify_ts_1 = require("purify-ts");
const non_empty_list_1 = require("@codegrade/non-empty-list");
const base_1 = require("./base");
const utils_1 = require("./utils");
class CodeQualityAutoTestStep extends base_1.BaseAutoTestStep {
    parseInputData(data) {
        return data;
    }
    getDataToSave() {
        const base = this._baseGetDataToSave();
        let errs = [];
        const wrapper = this.data.wrapper;
        if (wrapper == null) {
            const existing = base
                .mapLeft(baseErrs => [...baseErrs, ...errs])
                .swap()
                .orDefault([]);
            const res = (0, non_empty_list_1.NonEmptyList)(['Please select a wrapper']).concat(existing);
            return (0, purify_ts_1.Left)(res);
        }
        else if (wrapper === 'custom') {
            errs = errs.concat(this._checkProgramNotEmpty());
        }
        const extra = (0, utils_1.errOrData)(errs, { type: this.type, data: { ...this.data, wrapper } });
        return (0, utils_1.mergeEithers)(base, extra);
    }
}
exports.CodeQualityAutoTestStep = CodeQualityAutoTestStep;
